import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-add-routes",
  templateUrl: "./add-routes.component.html",
  styleUrls: ["./add-routes.component.css"],
})
export class AddRoutesComponent implements OnInit {
  selectedOption = "1"; // Default to "Routes"
  addRoutesForm!: FormGroup;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  // @ViewChild("pickUpLocationSearchField")
  // pickUpLocation: ElementRef | any;
  // @ViewChild("dropLocationSearchField", { static: false })
  @ViewChild("dropLocationSearchField", { static: false })
  dropLocation!: ElementRef;
  @ViewChild("pickUpLocationSearchField", { static: false })
  pickUpLocation!: ElementRef;

  // dropLocation!: ElementRef;
  // dropLocation!: ElementRef;
  pickupPlace: any;
  completePickUpAddress: any;
  pickup_short_name: any = "";
  pickup_long_name: any = "";
  // Drop Off //
  dropAutoComplete: any;
  dropPlace: any;
  dropLat: any;
  dropLong: any;
  completeDropAddress: any;
  drop_long_name: any = "";
  drop_short_name: any = "";

  truckCategory: any = [];
  token: any;

  selectedValue = "route";

  constructor(
    private matDialogRef: MatDialogRef<AddRoutesComponent>,
    private fb: FormBuilder,
    private services: TruckOwnerService,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");

    this.getTruckCategory();
    this.addRoutesForm = this.fb.group({
      pickup_city: ["", Validators.required], // Initially required
      dropoff_city: ["", Validators.required], // Initially required
      truck_category: ["", Validators.required], // Always required
    });
  }
  close() {
    this.matDialogRef.close();
  }

  onRadioChange(event: any): void {
    this.selectedOption = event.value; // Store the selected value
    if (this.selectedOption === "2") {
      this.selectedValue = "pickup_city";
    } else {
      this.selectedValue = "route";
    }
    // Clear previous autocomplete instances
    if (this.dropAutoComplete) {
      google.maps.event.clearInstanceListeners(this.dropAutoComplete);
      this.dropAutoComplete = null;
    }

    if (this.pickupAutoComplete) {
      google.maps.event.clearInstanceListeners(this.pickupAutoComplete);
      this.pickupAutoComplete = null;
    }

    // Reinitialize based on the selected option
    if (this.selectedOption === "2" && this.pickUpLocation?.nativeElement) {
      this.initializePickUpAutocomplete();
      this.toggleFormValidations(false); // Only validate pickup_city when Pickup City is selected
    } else if (
      this.selectedOption !== "2" &&
      this.dropLocation?.nativeElement
    ) {
      this.initializeDropAutocomplete();
      this.toggleFormValidations(true); // Validate both pickup and dropoff when other option is selected
    }
  }

  ngAfterViewChecked(): void {
    // Reinitialize Drop Location Autocomplete
    if (
      this.selectedOption !== "2" &&
      this.dropLocation?.nativeElement &&
      !this.dropAutoComplete
    ) {
      this.addRoutesForm.reset();

      this.initializeDropAutocomplete();
    }

    // Reinitialize Pickup Location Autocomplete
    if (
      this.selectedOption === "2" &&
      this.pickUpLocation?.nativeElement &&
      !this.pickupAutoComplete
    ) {
      this.initializePickUpAutocomplete();
    }
  }

  initializeDropAutocomplete(): void {
    this.addRoutesForm.reset();

    const options = {
      componentRestrictions: { country: "in" },
    };
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );

    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const place = this.dropAutoComplete.getPlace();
        this.handleDropPlaceChange(place);
      }
    );
  }

  initializePickUpAutocomplete(): void {
    this.addRoutesForm.reset();

    const options = {
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );

    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        this.handlePickUpPlaceChange(place);
      }
    );
  }

  handleDropPlaceChange(place: any): void {
    const geoCoder = new google.maps.Geocoder();
    geoCoder.geocode(
      { address: place.formatted_address },
      (results: any, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.dropLat = results[0].geometry.location.lat();
          this.dropLong = results[0].geometry.location.lng();
          this.addRoutesForm.controls["dropoff_city"].setValue(
            place.formatted_address
          );
        }
      }
    );
  }

  handlePickUpPlaceChange(place: any): void {
    const geoCoder = new google.maps.Geocoder();
    geoCoder.geocode(
      { address: place.formatted_address },
      (results: any, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.pickupLat = results[0].geometry.location.lat();
          this.pickupLong = results[0].geometry.location.lng();
          this.addRoutesForm.controls["pickup_city"].setValue(
            place.formatted_address
          );
        }
      }
    );
  }

  toggleFormValidations(enableDropoff: boolean): void {
    if (enableDropoff) {
      // Add required validators for both fields
      this.addRoutesForm.get("pickup_city")?.setValidators(Validators.required);
      this.addRoutesForm
        .get("dropoff_city")
        ?.setValidators(Validators.required);
    } else {
      // Add required validation for pickup and remove from dropoff
      this.addRoutesForm.get("pickup_city")?.setValidators(Validators.required);
      this.addRoutesForm.get("dropoff_city")?.clearValidators(); // Remove validation
    }

    // Update validations
    this.addRoutesForm.get("pickup_city")?.updateValueAndValidity();
    this.addRoutesForm.get("dropoff_city")?.updateValueAndValidity();
  }
  ngAfterViewInit(): void {
    var options = {
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );

    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );

    // Add event listener for Pickup location
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        this.validateAndSetCity(place, "pickup_city");
      }
    );

    // Add event listener for Drop location
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const place = this.dropAutoComplete.getPlace();
        this.validateAndSetCity(place, "dropoff_city");
      }
    );
  }

  validateAndSetCity(place: any, formControlName: string): void {
    if (!place.address_components) {
      this.addRoutesForm.controls[formControlName].setValue(""); // Clear invalid input
      this.showErrorMessage("Please select a valid city.");
      return;
    }

    // Extract city information from address components
    const cityComponent = place.address_components.find(
      (component: any) =>
        component.types.includes("locality") && // Match city type
        component.types.includes("political")
    );

    if (cityComponent) {
      // Valid city found, set the form control
      const cityName = cityComponent.long_name;
      this.addRoutesForm.controls[formControlName].setValue(cityName);
    } else {
      // Invalid input, clear the form control and show an error
      this.addRoutesForm.controls[formControlName].setValue("");
      this.showErrorMessage("Please select a valid city from the suggestions.");
    }
  }

  showErrorMessage(message: string): void {
    this.snackbar.open(message, "Close", {
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  getTruckCategory() {
    this.services.getCategory().subscribe(
      (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          this.truckCategory = [...response.data]; // Populate all categories
        } else {
        }
      },
      (error) => {}
    );
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.addRoutesForm.value.pickup_city);
    // this.checkLocations();
  }

  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.pickupPlace = place;
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);

              // this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompletePickupGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      if (result && result.length) {
        this.completePickUpAddress = result[0];

        // Extract the locality (city) from address components
        const locality = this.completePickUpAddress.address_components.find(
          (component: any) =>
            component.types.includes("locality") && // City name
            component.types.includes("political")
        );

        if (locality) {
          const cityName = locality.long_name;

          // Set the city name in the form control
          this.addRoutesForm.controls["pickup_city"].setValue(cityName);
          this.pickup_short_name = cityName;
        } else {
          // Handle cases where locality is not found
          this.addRoutesForm.controls["pickup_city"].setValue("");
          this.showErrorMessage("Please select a valid city.");
        }
      } else {
        // Handle cases where geocode result is empty or undefined
        this.addRoutesForm.controls["pickup_city"].setValue("");
        this.showErrorMessage(
          "Unable to find a valid city for the selected location."
        );
      }
    });
  }

  onDropChange() {
    this.geoCodeDrop(this.addRoutesForm.value.dropoff_city);
    // this.checkLocations();
  }

  geoCodeDrop(address: any) {
    // Clear existing listeners
    google.maps.event.clearInstanceListeners(this.dropAutoComplete);
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.dropPlace = dropPlace;

        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },

          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);

              // this.checkLocations();
            }
          }
        );
      }
    );
  }

  autoCompleteDropGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      if (result.length) {
        this.completeDropAddress = result[0];
        // Extract the locality (city) from address components
        const locality = this.completeDropAddress.address_components.find(
          (component: any) =>
            component.types.includes("locality") && // City name
            component.types.includes("political")
        );

        // Set the city name in the form control
        if (locality) {
          const cityName = locality.long_name;

          this.addRoutesForm.controls["dropoff_city"].setValue(cityName);
          this.drop_short_name = cityName; // Store the short name of the city
        } else {
          // Handle cases where locality is not found
          this.addRoutesForm.controls["dropoff_city"].setValue("");
          this.showErrorMessage("Please select a valid city.");
        }
      }
    });
  }

  checkLocations() {
    const pickups = this.addRoutesForm.get("pickup_city")?.value;
    const dropup = this.addRoutesForm.get("dropoff_city")?.value;
    if (pickups && dropup && pickups === dropup) {
      return;
    }
  }
  addRoute() {
    const pickups = this.addRoutesForm.get("pickup_city")?.value;
    const dropup = this.addRoutesForm.get("dropoff_city")?.value;
    if (pickups && dropup && pickups === dropup) {
      this.snackbar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }
    if (this.addRoutesForm.valid) {
      if (this.pickup_short_name == "" || this.pickup_short_name == undefined) {
        this.snackbar.open("Please enter a valid pickup location", "Fail", {
          duration: 3000,
        });
        return;
      }
      if (this.selectedOption != "2") {
        if (this.drop_short_name == "" || this.drop_short_name == undefined) {
          this.snackbar.open("Please enter a valid dropup location", "Fail", {
            duration: 3000,
          });
          return;
        }
      }

      const data = {
        pickup_city: {
          from_area_name: this.pickup_long_name,
          from_city_name: this.pickup_short_name,
          from_pincode: this.extractPincode(this.completePickUpAddress), // Extract the pincode
          from_lat: (Math.round(this.pickupLat * 10000) / 10000).toString(), // Rounded latitude as string
          from_long: (Math.round(this.pickupLong * 10000) / 10000).toString(), // Rounded longitude as string
        },
        dropoff_city: {
          to_area_name: this.drop_long_name,
          to_city_name: this.drop_short_name,
          to_pincode: this.extractPincode(this.completeDropAddress),
          to_lat: (Math.round(this.dropLat * 10000) / 10000).toString(),
          to_long: (Math.round(this.dropLong * 10000) / 10000).toString(),
        },
        truck_category: this.addRoutesForm.value.truck_category,
        pre_order_type: this.selectedValue,
      };

      this.services.addRoute(data, this.token).subscribe((response: any) => {
        if (response.status === 200) {
          this.matDialogRef.close();
        }
      });
    }
  }
  // Method to extract the pincode from the address components
  extractPincode(addressComponents: any): number {
    for (let i = 0; i < addressComponents?.address_components.length; i++) {
      if (addressComponents?.address_components[i].types[0] === "postal_code") {
        return parseInt(addressComponents?.address_components[i].long_name, 10);
      }
    }
    return 0; // If no pincode is found, return 0
  }
}
